<template>
  <v-card :loading="showDialogProgress" :disabled="showDialogProgress">
  <div class="VacationManagement" >
    <request-management-search-panel
      :accessTo="accessTo"
      @search="setSearchParams"
    />

    <box class="mt-2" :title="$t('vacationList')">
      <div class="vacationList">
        <div v-if="list.length > 0">
          <vacation-management-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClickVacation="onClickVacation"
          />
          <vacation-management-list-mob
            @onClickVacation="onClickVacation"
            :list="list"
            class="hidden-md-and-up"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="d-flex px-4 py-2">
              <v-btn outlined color="primary" @click.stop="showInput = false" :loading="isLoading" :disabled="disabledBtn" small @click="approveSelected">{{
                $t("approveSelected")
              }}</v-btn>
              <v-btn
                outlined
                color="primary"
                class="mx-2"
                small
                @click="rejectSelected"
                >{{ $t("rejectSelected") }}</v-btn
              >
            </div>
          </v-card-actions>
        </div>
        <div v-else>
          <EmptyList :state="stateList" />
        </div>
      </div>
    </box>
    <vacation-management-details
      class="mt-2"
      ref="VacationManagementDetails"
      @refresh="search"
      @operationOnRequest="operationOnRequestDetails"
    />
  </div>
</v-card>
</template>

<script>
import RequestManagementSearchPanel from "../../components/requestManagement/RequestManagementSearchPanel.vue";
import VacationManagementListWeb from "../../components/requestManagement/vacation/VacationManagementListWeb.vue";
import VacationManagementListMob from "../../components/requestManagement/vacation/VacationManagementListMob.vue";
import VacationManagementDetails from "../../components/requestManagement/vacation/VacationManagementDetails.vue";
import RequestState from "@/model/RequestState";
import ResultType from "../../model/ResultType";
import AccessToType from "../../model/AccessToType";
import TextUtils from "../../utils/TextUtils";
import EosToastType from "../../model/EosToastType";
import StateList from "../../model/StateList";
import EosUtils from "../../utils/EosUtils";
import PushNotificationHelper from "../../notification/PushNotificationHelper";

export default {
  components: {
    RequestManagementSearchPanel,
    VacationManagementListWeb,
    VacationManagementListMob,
    VacationManagementDetails,
  },
  data() {
    return {
      // accessTo: -1,
      accessTo: 56,
      list: [],
      searchParams: {},
      stateList: null,
      reasonOfAdmin:"",
      isLoading: false,
      showDialogProgress: false,
      disabledBtn:false,
    };
    
  },
  created() {
    this.accessTo = AccessToType.Vacation;
    //console.log(this.accessTo);
  },
  methods: {
    setSearchParams(params) {
      this.searchParams = params;
      this.search();
    },
    search() {
      //console.log(params);
      var params = this.searchParams;
      ////debugger
      this.list = [];
      this.stateList = StateList.loading();

      this.$store
        .dispatch("GetVacationListForAdmins", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            ////debugger
            this.list = result.data;
            this.stateList = null;
          } else {
            this.stateList = StateList.error(result.error);
          }
        });
    },
    onClickVacation(item) {
      this.hideDetails();
      //console.log(item);
      this.$refs.VacationManagementDetails.show(item);
      /**/
    },
    hideDetails() {
      this.$refs.VacationManagementDetails.hide();
    },

     approveSelected() {
      //debugger
      this.disabledBtn=true;
      this.showDialogProgress=true
     
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Approve;
      ////debugger
      if (selectedList.length > 0) {
        this.disabledBtn=true;
        this.showDialogProgress=true
        this.OprationOnRequest(requestState, selectedList);
      } else {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "حداقل یک مورد را انتخاب نمایید",
        });
      }
      // this.disabledBtn=false;
      // this.showDialogProgress=false;
      setTimeout(() => {
        this.disabledBtn=false;
      this.showDialogProgress=false
      }, 2000);
      return;

    },
    rejectSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      // ////debugger;
      var requestState = RequestState.RequestState.Reject;
      var txtAdminParaf="";
      this.OprationOnRequest(requestState, selectedList,txtAdminParaf);
    },
    operationOnRequestDetails(requestState, selectedList,txtAdminParaf) {
      ////debugger;
      this.reasonOfAdmin=txtAdminParaf,
      this.OprationOnRequest(requestState, selectedList,txtAdminParaf);
    },
    async OprationOnRequest(requestState, selectedList,txtAdminParaf) {
      //console.log(selectedList);Status
      //debugger;
      var params = [];
      var adminPerno = this.$store.state.auth.auth.username;

      if (EosUtils.isWebKartAdmin()) {
        //
        selectedList.forEach((item) => {
          var param = {
            
            PageNo: TextUtils.convertToEnglishDigits(
              item.Pageno.toString().trim()
            ),
            Year: item.Year,
            adminPerno: adminPerno,
            perno: TextUtils.convertToEnglishDigits(
              item.Perno.toString().trim()
            ),
            RequestState: requestState,

            ReasonOfAdmin: txtAdminParaf,
            Status: 10,
          };
          params.push(param);
        });
        //////debugger;
        this.OprationOnVacationRequest(params);
      } else {
        //
        let callback = function (resList) {
          ////debugger;
          //console.log(resList);
          resList.forEach((res, index) => {
            if (res.type === ResultType.success) {
             var s = res.data;
              ////debugger
              //console.log(s, index);
              ////debugger
              var item = selectedList[index];
              var param = {
                PageNo: TextUtils.convertToEnglishDigits(
                  item.Pageno.toString().trim()
                ),
                Year: item.Year,
                adminPerno: adminPerno,
                perno: TextUtils.convertToEnglishDigits(
                  item.Perno.toString().trim()
                ),
                RequestState: requestState,
                
                 ReasonOfAdmin: txtAdminParaf,
                // ReasonOfAdmin:"",
                Status:s ,
                
              };
              //debugger
              console.log('param:'+param)
              params.push(param);
              console.log('params:'+params)
              //debugger
              // this.OprationOnVacationRequest(params);
              
            }
          });
        };
        if (selectedList.length > 0) {
          ////debugger;
          await this.GetApproveDegree(selectedList, callback).then(() => {
            ////debugger
            this.OprationOnVacationRequest(params);
          });
        }
      }
    },
    async GetApproveDegree(list, callback) {
      let promises = [];
      list.forEach((item) => {
////debugger;
        //console.log(item);
        var approveParams = {
          perno: TextUtils.convertToEnglishDigits(item.Perno.toString().trim()),
          section: TextUtils.convertToEnglishDigits(
            item.Section.toString().trim()
          ),
          status: TextUtils.convertToEnglishDigits(
            item.Status.toString().trim()
          ),
          // status:10,
          pageType: TextUtils.convertToEnglishDigits(
            item.Type.toString().trim()
          ),
        };
////debugger;
        promises.push(
          this.$store.dispatch("GetVacationApproveDegree", { approveParams })
        );
      });

      await Promise.all(promises)
        .then(callback)
        .catch((err) => {
          console.log(err);
        });
    },
    OprationOnVacationRequest(params) {
      //console.log(params);
     //debugger;
      this.$store
        .dispatch("OprationOnVacationRequest", { params })
        .then((result) => {
          console.log(result);
          if (result.type === "success") {
            this.search();
            if (result.data && result.data.length > 0) {
              var description = result.data[0].Description;
              this.$EosToast.show({
                type: EosToastType.success,
                msg: description,
              });
              //this.$refs.snackbar.show("success", description);
              params.forEach((param) => {
                PushNotificationHelper.sendNotification(
                  param.adminPerno,
                  param.perno,
                  param.RequestState,
                  param.RequestState
                );
              });
              //////debugger;
              // result.data.forEach((data, i) => {
              //   var description = data.Description;
              //   var type = EosToastType.success;
              //   if (data.Status == "-1") {
              //     //////debugger;
              //     type = EosToastType.error;
              //   } else {
              //     //////debugger;
              //     PushNotificationHelper.sendNotification(
                  
              //       params[i].adminPerno,
              //       params[i].perno,
              //       params[i].RequestState,
              //       params[i].RequestState
              //     );
              //   }
              //   this.$EosToast.show({
              //     type: type,
              //     msg: description,
              //   });
              // });
            }
          } else {
            //////debugger;
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error,
            });
          }
        });
    },
  },
};
</script>

<style>
</style>
